<section class="testimonial-area bg-color-gray">
    <div class="container" data-aos="fade-down">
        <div class="row">
            <div class="col-12">
                <div class="section-title text-center">
                    <h3 class="title">Our Happy Clients</h3>
                    <div class="desc">
                        <p>Many desktop publishing packages and web page editors</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">


                <div class="testimonial-area">
                    <div class="">
                        <div class="testimonials123 owl-carousel owl-theme">
                            <div class="item" *ngFor="let monials of testMonialsList">
                                <div class="testimonial-item">
                                    <div class="testi-inner-content">
                                        <div class="testi-author">
                                            <div class="d-flex justify-content-between">
                                                <div class="testi-thumb">
                                                    <img [src]="monials.image" class="img-fluid" width="75" height="75"
                                                        alt="{{monials.name}}">
                                                </div>
                                                <div class="testi-info">
                                                    <h4 class="name">{{ monials.name }}</h4>
                                                    <span class="designation">{{ monials.designation }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="testi-content">
                                            <p class="desc">{{ monials.description }}</p>
                                            <div class="rating-box">
                                                <i class="icofont-star" *ngFor="let star of [1,2,3,4,5]"></i>
                                            </div>
                                            <div class="testi-quote">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="bi bi-quote" viewBox="0 0 16 16">
                                                    <path
                                                        d="M12 12a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1h-1.388q0-.527.062-1.054.093-.558.31-.992t.559-.683q.34-.279.868-.279V3q-.868 0-1.52.372a3.3 3.3 0 0 0-1.085.992 4.9 4.9 0 0 0-.62 1.458A7.7 7.7 0 0 0 9 7.558V11a1 1 0 0 0 1 1zm-6 0a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1H4.612q0-.527.062-1.054.094-.558.31-.992.217-.434.559-.683.34-.279.868-.279V3q-.868 0-1.52.372a3.3 3.3 0 0 0-1.085.992 4.9 4.9 0 0 0-.62 1.458A7.7 7.7 0 0 0 3 7.558V11a1 1 0 0 0 1 1z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
<!--== End Testimonial Area Wrapper ==-->